import { render, staticRenderFns } from "./SurveyStatusModal.vue?vue&type=template&id=5dd654cf&scoped=true&"
import script from "./SurveyStatusModal.vue?vue&type=script&lang=js&"
export * from "./SurveyStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./SurveyStatusModal.vue?vue&type=style&index=0&id=5dd654cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd654cf",
  null
  
)

export default component.exports